// eslint-disable-next-line no-unused-vars
import { ILanguage } from './ILanguage';

export default {
  title: 'Manage your account',
  titleApps: 'Access apps',
  clientApp: {
    text: 'Access keys',
    title: 'Click here to access your keys',
  },
  clientAdmin: {
    text: 'Access admin module',
    title: 'Click here to access admin module',
  },
  clientWebJobs: {
    text: 'Emails report',
    title: 'Click here to access report of sent emails',
  },
  changeName: {
    text: 'Change name',
    title: 'Click here to change the name used by system',
  },
  changeEmail: {
    text: 'Change email',
    title: 'Click here to change your email',
  },
  changePassword: {
    text: 'Change password',
    title: 'Click here to change your password',
  },
  signOut: {
    text: 'Close connection',
    title: 'Click here to safely end your connection',
  },
} as ILanguage;
